import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import UsersListing from "./UsersListing";
import DataPerPage from "../../../CommonComponents/Pagination/DataPerPage";
import SearchComponent from "../../../CommonComponents/SearchComponent/SearchComponent";
import "../admin.css";

const Users = () => {
    const [dataPerPage, setDataPerPage] = useState(10)
    const [selectAction, setSelectAction] = useState('action')
    const [totalData, setTotalData] = useState(0)

    return (
        <>
            <div className="admin-module">
                <div className="admin-user-page admin-content">
                    <Breadcrumb string="Admin / Users" />

                    <div className="container admin-user-container">
                        <div className=" mb-4 show-select1 d-flex admin-user-header">
                            <div className="admin-user-controls admin-user-search-group">
                                {totalData > dataPerPage && <DataPerPage dataPerPage={dataPerPage} setDataPerPage={setDataPerPage} />}
                                <div className="admin-user-search-input-wrap">
                                    <SearchComponent
                                        data={[]}
                                        setCurrentPageData={() => {}}
                                        placeholder="Search here"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="admin-user-search-btn"
                                    aria-label="Search"
                                >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                            </div>

                            <div className="admin-user-action-dropdown">
                                <select
                                    id="user-action-select"
                                    className="admin-user-select"
                                    onChange={(e) => setSelectAction(e.target.value)}
                                    value={selectAction}
                                    aria-label="Select action for users"
                                >
                                    <option value="action">Select Action</option>
                                    <option value="delete">Delete Selected</option>
                                    <option value="sendMail">Resend Signup Verification</option>
                                    <option value="bulkDomain">Assign Domains</option>
                                </select>
                            </div>
                        </div>

                        <UsersListing
                            dataPerPage={dataPerPage}
                            selectAction={selectAction}
                            setSelectAction={setSelectAction}
                            onTotalDataChange={setTotalData}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Users;
